import { Box, Stack } from '@mui/material';
import ItemId from 'components/drawers/products-drawer/item-id.component';

const ProductListSingleItemListItem = ({ item }) => {
  return (
    <Stack spacing={1}>
      <Box>{item.label}</Box>
      <ItemId item={item} />
    </Stack>
  );
};

export default ProductListSingleItemListItem;
